import { getNextActiveElement, isElement, isVisible } from "./dom.js";
const ARROW_UP_KEY = "ArrowUp";
const ARROW_DOWN_KEY = "ArrowDown";
const ENTER_KEY = "Enter";
const ITEM_FOCUS_CLASS = "focus";
const defaults = Object.freeze({
  itemContainer: null,
  // HTMLElement
  itemSelector: ".dropdown-item:not(.disabled), .dropdown-item:not(:disabled)",
  itemFocusClass: ITEM_FOCUS_CLASS,
  /**
   * The selector for the event trigger
   */
  itemSelectSelector: "",
  /**
   * The keys to trigger selection
   */
  itemSelectKeys: [ENTER_KEY],
  /**
   * The events to trigger on selection (enter/space)
   */
  itemSelectEvents: ["click"]
});
let activeInstance = null;
const setupListKeyboardNavigation = (options) => {
  if (!options || !options.itemContainer) {
    throw Error("You must define an item container");
  }
  const opts = { ...defaults, ...options };
  const { itemContainer, itemSelector, itemFocusClass, itemSelectSelector, itemSelectEvents, itemSelectKeys } = opts;
  const getItems = () => {
    if (!itemContainer || !isElement(itemContainer)) {
      return [];
    }
    const items = [...itemContainer.querySelectorAll(`${itemSelector}`)];
    return items.filter((element) => isVisible(element));
  };
  const getFocusedItem = () => {
    return getItems().find((item) => item.classList.contains(itemFocusClass));
  };
  const clearFocusedState = () => {
    getItems().forEach((item) => item.classList.remove(itemFocusClass));
  };
  const setFocusedItem = (el) => {
    clearFocusedState();
    el == null ? void 0 : el.classList.add(itemFocusClass);
  };
  const listKeydown = (e) => {
    if ([ARROW_UP_KEY, ARROW_DOWN_KEY].includes(e.key)) {
      e.preventDefault();
      const items = getItems();
      if (!items.length) {
        return;
      }
      const target = getFocusedItem() ?? e.target;
      const activeElement = getNextActiveElement(items, target, e.key === ARROW_DOWN_KEY, false);
      setFocusedItem(activeElement);
      adjustScroll(activeElement);
    }
    if (itemSelectKeys.includes(e.key)) {
      if (getFocusedItem()) {
        e.preventDefault();
        const focusedItem = getFocusedItem();
        const el = itemSelectSelector ? focusedItem == null ? void 0 : focusedItem.querySelector(itemSelectSelector) : getFocusedItem();
        itemSelectEvents.forEach((e2) => {
          const event = new Event(e2);
          if (el) {
            el.dispatchEvent(event);
          }
        });
      }
    }
  };
  const init = () => {
    if (activeInstance === instance) ;
    else {
      if (activeInstance) {
        console.warn("There can only be one instance of list navigation active at a time.");
        activeInstance.destroy();
      }
      document.addEventListener("keydown", listKeydown);
      activeInstance = instance;
    }
  };
  const destroy = () => {
    clearFocusedState();
    document.removeEventListener("keydown", listKeydown);
    activeInstance = null;
  };
  const adjustScroll = (activeOptionEl) => {
    if (!itemContainer || !isElement(itemContainer)) {
      return;
    }
    const bounds = itemContainer.getBoundingClientRect();
    const { top, bottom } = activeOptionEl.getBoundingClientRect();
    if (top < bounds.top) {
      activeOptionEl.scrollIntoView({ behavior: "auto", block: "nearest", inline: "start" });
    } else if (bottom > bounds.bottom) {
      activeOptionEl.scrollIntoView({ behavior: "auto", block: "nearest", inline: "end" });
    }
  };
  const instance = { getItems, getFocusedItem, clearFocusedState, setFocusedItem, listKeydown, init, destroy };
  init();
  return instance;
};
export {
  ITEM_FOCUS_CLASS,
  setupListKeyboardNavigation
};
